import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const StepperControls = ({
  activeStep,
  handleNext,
  handleBack,
  handleReset,
  stepsLength,
  isCheckboxChecked,
  allStepsCompleted,
  isFormSubmitted
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, justifyContent: 'flex-end', gap: 2 }}>
      {activeStep > 0 && activeStep < 3 && (
        <Button
          onClick={handleBack}
          sx={{ backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}
        >
          Atrás
        </Button>
      )}
      {activeStep < stepsLength - 1 && (
        <Button
          variant="contained"
          onClick={handleNext}
          disabled={(activeStep === 1 && !isCheckboxChecked) || (!isFormSubmitted && activeStep === 2)}
          sx={{ backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}
        >
          Siguiente
        </Button>
      )}
      {activeStep === stepsLength - 1 && !allStepsCompleted() && (
        <Button
          variant="contained"
          onClick={handleNext}
          sx={{ backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}
        >
          Finalizar
        </Button>
      )}
    </Box>
  );
};

export default StepperControls;